module.exports = __webpack_public_path__ + "static/media/logo5@2x.5bf16ec8.png";